export default "__VITE_PUBLIC_ASSET__0a4b1f70__"